// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"InviteButtons_iconButton__3skVc"};